import React from 'react';

const EMOJI_LIST = [
  '😀', '😂', '😍', '🥳', '😎',
  '🤔', '👍', '👏', '🎉', '🔥',
  '❤️', '💯', '✅', '⭐', '🚀',
  '👋', '🙌', '😢', '😱', '🤣',
  '👀', '💪', '🎯', '✨', '🤝',
  '⏳', '☕', '🔔', '📌', '💬'
];

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}

export const EmojiPicker = ({ onSelect, onClose }: EmojiPickerProps) => (
  <div className="absolute bottom-full left-0 mb-[4px] bg-white dark:bg-[#28282B] rounded-[12px] border border-[rgba(0,0,0,0.11)] dark:border-[rgba(255,255,255,0.08)] shadow-[0_4px_20px_rgba(0,0,0,0.1)] p-[8px] w-[220px]">
    <div className="grid grid-cols-6 gap-[2px]">
      {EMOJI_LIST.map((emoji) => (
        <button
          key={emoji}
          type="button"
          onClick={() => {
            onSelect(emoji);
            onClose();
          }}
          className="w-[32px] h-[32px] flex items-center justify-center rounded-[6px] text-[18px] hover:bg-[#F0F0F2] dark:hover:bg-[#333336] transition-colors"
        >
          {emoji}
        </button>
      ))}
    </div>
  </div>
);
